// src/components/NumeroOrdineCommessa.js
// «N. ordine» della commessa (W440): il numero d'ordine interno dell'azienda (es. quello del
// suo gestionale), facoltativo, diverso dal codice commessa di Nexiora. Compare in prima
// colonna in Le mie commesse, Richieste di fatturazione e Registro Commesse.
// Lo scrivono titolare, amministratori e il responsabile della commessa.
import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useToast } from "../utils/Toast";
import { messaggioErrore } from "../utils/erroriUtente";
import { pulisciNumeroOrdine } from "../utils/numeroOrdine";

export default function NumeroOrdineCommessa({ projectId, valore = "", puoModificare = false, onSalvato, compatto = false }) {
  const { addToast } = useToast();
  const [testo, setTesto] = useState(null); // null = non in modifica
  const [salvo, setSalvo] = useState(false);
  const salva = async () => {
    const nuovo = pulisciNumeroOrdine(testo);
    if (nuovo === (valore || "")) { setTesto(null); return; }
    setSalvo(true);
    try { await updateDoc(doc(db, "projects", projectId), { numeroOrdine: nuovo }); onSalvato && onSalvato(nuovo); setTesto(null); addToast(nuovo ? `N. ordine ${nuovo} salvato` : "N. ordine tolto", "success"); }
    catch (e) { addToast(messaggioErrore(e), "error"); }
    setSalvo(false);
  };
  if (testo !== null) return (
    <span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>
      <input autoFocus aria-label="N. ordine" value={testo} maxLength={40} onChange={e => setTesto(e.target.value)} placeholder="es. 4500123"
        onKeyDown={e => { if (e.key === "Enter") salva(); if (e.key === "Escape") setTesto(null); }}
        style={{ width: compatto ? 110 : 130, padding: "3px 7px", border: "1px solid #c4b5fd", borderRadius: 6, fontSize: 12, fontFamily: "'Inter',sans-serif" }} />
      <button type="button" onClick={salva} disabled={salvo} aria-label="Salva N. ordine" style={{ border: "none", background: "#7c3aed", color: "#fff", borderRadius: 6, padding: "3px 8px", fontSize: 11.5, fontWeight: 700, cursor: "pointer" }}>{salvo ? "…" : "OK"}</button>
      <button type="button" onClick={() => setTesto(null)} aria-label="Annulla" style={{ border: "1px solid #e5e7eb", background: "#fff", borderRadius: 6, padding: "3px 7px", fontSize: 11.5, cursor: "pointer" }}>✕</button>
    </span>
  );
  if (!valore) return puoModificare
    ? <button type="button" onClick={() => setTesto("")} title="Il numero d'ordine interno dell'azienda (es. del gestionale)" style={{ border: "1px dashed #c4b5fd", background: "#faf5ff", color: "#6d28d9", fontSize: 11.5, fontWeight: 700, borderRadius: 7, padding: "1px 8px", cursor: "pointer", whiteSpace: "nowrap", fontFamily: "'Inter',sans-serif" }}>+ N. ordine</button>
    : <span style={{ color: "#d1d5db" }}>—</span>;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, whiteSpace: "nowrap" }}>
      <span title="N. ordine dell'azienda" style={{ fontWeight: 800, color: "#1e1b4b", fontFamily: "'Inter',sans-serif" }}>{compatto ? "" : "N. ordine "}{valore}</span>
      {puoModificare && <button type="button" onClick={() => setTesto(valore)} aria-label="Modifica N. ordine" style={{ border: "none", background: "none", color: "#7c3aed", cursor: "pointer", fontSize: 11, padding: 0 }}>✎</button>}
    </span>
  );
}
